
package waldo.sankan.lineamunicipalkmp.web.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import waldo.sankan.lineamunicipalkmp.model.Incidencia
import kotlin.js.Date

// --- ¡UNIDAD DE VISUALIZACIÓN DE ÉLITE, AHORA REUTILIZABLE! ---

@Composable
fun IncidentsTable(
    incidencias: List<Incidencia>,
    onIncidenciaClick: (Incidencia) -> Unit
) {
    Table({
        style {
            width(100.percent)
            property("border-collapse", "collapse")
            fontSize(14.px)
            color(Color("#333333"))
        }
    }) {
        Thead {
            Tr {
                // --- ¡SINTAXIS CORREGIDA! Usamos 'property' para los bordes --- 
                Th(attrs = { style { padding(12.px); textAlign("left"); property("border-bottom", "1px solid #1565C0") } }) { Text("ID Incidencia") }
                Th(attrs = { style { padding(12.px); textAlign("left"); property("border-bottom", "1px solid #1565C0") } }) { Text("Estado") }
                Th(attrs = { style { padding(12.px); textAlign("left"); property("border-bottom", "1px solid #1565C0") } }) { Text("Tipo") }
                Th(attrs = { style { padding(12.px); textAlign("left"); property("border-bottom", "1px solid #1565C0") } }) { Text("Fecha Creación") }
                Th(attrs = { style { padding(12.px); textAlign("left"); property("border-bottom", "1px solid #1565C0") } }) { Text("Comuna") }
            }
        }
        Tbody {
            if (incidencias.isEmpty()) {
                Tr {
                    Td(attrs = { 
                        attr("colspan", "5") // ¡SINTAXIS CORREGIDA!
                        style { 
                            padding(16.px)
                            textAlign("center")
                            fontStyle("italic")
                        }
                    }) { Text("No se encontraron incidencias con los filtros seleccionados.") }
                }
            } else {
                incidencias.forEach { incidencia ->
                    Tr(attrs = {
                        onClick { onIncidenciaClick(incidencia) }
                        style {
                            cursor("pointer")
                            property("transition", "background-color 0.2s ease-in-out")
                        }
                        // Aplicamos el hover directamente aquí
                        onMouseOver { style { backgroundColor(Color("#1E88E5")) } }
                        onMouseOut { style { backgroundColor(Color.transparent) } }
                    }) {
                        Td(attrs = { style { padding(12.px) } }) { Text(incidencia.id) }
                        Td(attrs = { style { padding(12.px) } }) { BadgeForState(incidencia.estado) }
                        Td(attrs = { style { padding(12.px) } }) { Text(incidencia.tipoIncidenciaDisplayName ?: "N/A") }
                        Td(attrs = { style { padding(12.px) } }) { Text(incidencia.fechaCreacion?.let { formatTimestamp(it) } ?: "N/A") }
                        Td(attrs = { style { padding(12.px) } }) { Text(incidencia.comunaDisplayName ?: "N/A") }
                    }
                }
            }
        }
    }
}

@Composable
private fun BadgeForState(estado: String) {
    val (bgColor, textColor) = when (estado) {
        "SOLUCIONADO" -> "#4CAF50" to "#FFFFFF"
        "EN_PROCESO" -> "#FFC107" to "#000000"
        "RECHAZADO" -> "#F44336" to "#FFFFFF"
        "VERIFICADO" -> "#2196F3" to "#FFFFFF" 
        else -> "#607D8B" to "#FFFFFF"
    }

    Span(attrs = {
        style {
            backgroundColor(Color(bgColor))
            color(Color(textColor))
            padding(4.px, 8.px)
            borderRadius(12.px)
            fontSize(12.px)
            fontWeight("bold")
        }
    }) {
        Text(estado)
    }
}

private fun formatTimestamp(timestamp: Long): String {
    if (timestamp == 0L) return "N/A"
    val date = Date(timestamp)
    return date.toLocaleString("es-CL")
}
